import React from 'react';
import { useNavigate } from "react-router-dom";

const Header = ({ title, showBack, rightAction }) => {
  const navigate = useNavigate();
  return (
    <header className="bg-indigo-600 text-white p-4 sticky top-0 z-40">
      <div className="max-w-lg mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          {showBack && (
            <button onClick={() => navigate(-1)} className="p-1 hover:bg-indigo-500 rounded" data-testid="back-button">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          )}
          <h1 className="text-xl font-bold">{title}</h1>
        </div>
        {rightAction}
      </div>
    </header>
  );
};

export default Header;
